import { SESSION_STORAGE_KEYS as _SESSION_STORAGE_KEYS } from "repoV2/features/Common/modules/Storage/Storage.constants";

export const SESSION_STORAGE_KEYS = _SESSION_STORAGE_KEYS;
